import apiClient from "@/axiosConfig";

export default {
  async getPaymentJournal(openItemId, after = 0) {
    const response = await apiClient.get("/banking/payment-journal", { params: { openItemId, after, limit: 100 } });
    return response.data;
  },

  async recordManualPayment(openItemId, payload) {
    const response = await apiClient.post(`/banking/open-items/${encodeURIComponent(openItemId)}/manual-payments`, payload);
    return response.data;
  },

  async reverseManualPayment(entryId, payload) {
    const response = await apiClient.post(`/banking/manual-payments/${encodeURIComponent(entryId)}/reversal`, payload);
    return response.data;
  },

  async getAccounts() {
    const response = await apiClient.get("/banking/accounts");
    return response?.data || [];
  },

  async getTransactions(providerId, accountId, from, to) {
    const response = await apiClient.get(
      `/banking/accounts/${encodeURIComponent(providerId)}/${encodeURIComponent(accountId)}/transactions`,
      { params: { from, to } }
    );
    return response?.data || [];
  },

  async getOpenItems() {
    const response = await apiClient.get("/banking/open-items");
    return response?.data || [];
  },

  async findInvoiceCandidates(invoiceNumber) {
    const response = await apiClient.get("/banking/invoice-candidates", { params: { invoiceNumber } });
    return response?.data || [];
  },

  async registerInvoice(invoiceId, paymentDirection = "Incoming") {
    const response = await apiClient.post(`/banking/open-items/invoices/${encodeURIComponent(invoiceId)}`, {}, {
      params: { paymentDirection },
    });
    return response?.data || null;
  },

  async getInvoicePaymentStatus(invoiceId) {
    const response = await apiClient.get(`/banking/invoices/${encodeURIComponent(invoiceId)}/payment-status`);
    return response?.data || null;
  },

  async getFintsConnections() {
    const response = await apiClient.get("/banking/fints/connections");
    return response?.data || [];
  },

  async startFintsSync(payload) {
    const response = await apiClient.post("/banking/fints/sync-runs", payload);
    return response?.data || null;
  },

  async discoverFintsAccounts(connectionId) {
    const response = await apiClient.post("/banking/fints/account-runs", { connectionId });
    return response.data;
  },

  async setAccountActive(providerId, accountId, isActive) {
    const response = await apiClient.put(`/banking/accounts/${encodeURIComponent(providerId)}/${encodeURIComponent(accountId)}/active-state`, { isActive });
    return response.data;
  },

  async getMatchSuggestions(providerId, accountId, from, to) {
    const response = await apiClient.get("/banking/match-suggestions", {
      params: { providerId, accountId, from, to },
    });
    return response?.data || [];
  },

  async confirmMatch(payload) {
    const response = await apiClient.post("/banking/matches", payload);
    return response?.data || null;
  },

  async reverseMatch(allocationEntryId, payload) {
    const response = await apiClient.post(
      `/banking/matches/${encodeURIComponent(allocationEntryId)}/reversal`,
      payload
    );
    return response?.data || null;
  },
};
